import { push } from '@lagunovsky/redux-react-router'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import Typography from '../../components/Typography/Typography'
import ErrorWindow from '../../components/Windows/ErrorWindow/ErrorWindow'
import { getCinemaSlug } from '../Hall/helpers'

import hocExpiredLimit from './hocExpiredLimit'

import './ExpiredLimit.scss'

const ExpiredLimit = ({ eventid, cinemaid }) => {
    const intl = useIntl()
    const dispatch = useDispatch()
    const site = getCinemaSlug(cinemaid)
    const referer = localStorage.getItem('referer')

    return (
        <Container fluid className="expired-limit d-flex flex-column align-items-center">
            <Typography variant={'h1'} className={'me-auto'}>
                {intl.formatMessage({ id: 'expiredLimit.pageTitle' })}
            </Typography>
            <ErrorWindow
                title={intl.formatMessage({ id: 'expiredLimit.title' })}
                description={intl.formatMessage({ id: 'expiredLimit.description' })}
                textButton1={intl.formatMessage({ id: 'expiredLimit.button' })}
                onClickButton1={() => dispatch(push(`/?eventid=${eventid}&site=${site}&ref=${referer}`))}
            />
            <img
                src={'images/cinestar/astronaut-with-mobile.png'}
                alt={'astronaut-with-mobile'}
                className={'astronaut-animate w-50 h-auto mt-10'}
            />
        </Container>
    )
}

export default hocExpiredLimit(ExpiredLimit)
